<template>
	<section class="Miniapp" :class="{ active }">
		<div class="dismiss" @click="onClickDismiss"></div>
		<div class="model" ref="model">
			<iframe ref="iframe" allow="geolocation" v-if="active" :src="url" />
		</div>
	</section>
</template>

<script>
	import whevent from 'whevent';
	import store from '../store';
	import { mapState } from 'vuex';
	import { saveVariable } from '../services/userVariables';
	import { toHex, encode_link, decode_link, htmldecode } from '../libs/legacy';

	export default {
		data() {
			return {
				miniapp: null,
				showing: false,
				binded: false
			};
		},

		methods: {
			onMiniapp(miniapp) {
				this.logX('MINIAPP', 'steelblue', miniapp);
				this.miniapp = miniapp;
				this.showing = true;
			},

			onClickDismiss() {
				this.showing = false;
			},

			onWindowMessage({ data: msg, origin }) {
				if (msg.from !== 'anybot' || !msg.type) return;
				this.logX('MESSAGE', 'steelblue', msg.type, msg);
				if (!msg && !msg.from == 'anybot') return;
				// close
				if (msg.type == 'close_widget') {
					this.showing = false;
					// if (me.is_show_miniapp() && params.closeChat) return params.closeChat();
					// if (me.menu) $.remove(me.menu);
					// set title
				} else if (msg.type == 'set_widget_title') {
					// if (me.menu_title) me.menu_title.innerHTML = msg.title || '';
					// イベント予約
				} else if (msg.type == 'eventreserve') {
					// if (me.menu) $.remove(me.menu);
					// let qa = msg.code ? decode_link(msg.code, 'widget://event-programs') : {};
					// let type = !empty(msg.act) ? 'act' : 'funcs_eventreserve';
					// let el = {
					// 	msg_type: msg.type,
					// 	textContent: T('event.act.widget.reserve'), //msg
					// 	type: type,
					// 	rid: qa.rid,
					// 	aid: qa.aid,
					// 	did: msg.did,
					// 	dcd: msg.dcd,
					// 	tp: msg.tp || 'items'
					// };
					// me.onBtnClicked({ target: el, stopPropagation: function() {} });
					// minapp: ユーザーデータを更新する
				} else if (['miniapp_save', 'update_changes'].includes(msg.type)) {
					// update changes
					for (let [k, v] of Object.entries(msg.changes || {})) {
						if (k === 'id') continue;
						saveVariable(k, v);
					}
					// minapp: open url
				} else if (msg.type == 'miniapp_trans_uri') {
					let qa = msg.code ? decode_link(msg.code, 'widget://app') : {};
					let linkto = msg.uri || '';
					if (linkto) {
						let type = 'act';
						let el = {
							msg_type: msg.type,
							textContent: htmldecode(msg.text) || '',
							type: type,
							rid: qa.rid,
							aid: qa.aid,
							did: msg.did,
							dcd: msg.dcd,
							tp: msg.tp || 'btns'
						};
						el.linkto = linkto;
						['view_id', 'view_cid', 'view_itemid', 'view_itemtp'].forEach(k => (el[k] = msg[k]));
						whevent.emit('MINIAPP_REPLY', el);
						// me.onBtnClicked({ target: el, stopPropagation: function() {} });
					}
					// miniapp: ボタンでアクションを実行する
				} else if (msg.type == 'miniapp_trans_chat') {
					this.showing = false;

					let qa = msg.code ? decode_link(msg.code, 'widget://app') : {};
					if (msg.act) {
						let type = 'act';
						let el = {
							msg_type: msg.type,
							textContent: htmldecode(msg.text) || '',
							type: type,
							rid: qa.rid,
							aid: qa.aid,
							did: msg.did,
							dcd: msg.dcd,
							tp: msg.tp || 'btns'
						};
						el.act = msg.act;
						el.forward_act = msg.forward_act;
						['view_id', 'view_cid', 'view_itemid', 'view_itemtp'].forEach(k => (el[k] = msg[k]));
						whevent.emit('MINIAPP_REPLY', el);

						// me.onBtnClicked({ target: el, stopPropagation: function() {} });
						// // show action
						// agent.perform(me.user, msg.act);
					}
					// アクションを実行し、reactionなし
				} else if (msg.type == 'forward_chat') {
					if (this.active) return;

					if (!msg.no_close) {
						this.showing = false;
					}

					if (!msg.act) return;

					// if (agent) agent.perform(agent.user, msg.act);
					// ユーザーデータを更新する
				} else if (msg.type == 'tasklist') {
					this.showing = false;

					// if (me.menu) $.remove(me.menu); // close widget
					//         	let qa = msg.code?decode_link(msg.code,"widget://tasklist"):{};
					//         	let type = msg.act;
					//         	let el = {
					//         		textContent: msg.result||"",//msg
					// 				type:type,rid:qa.rid,aid:qa.aid, did:msg.did,dcd:msg.dcd,tp:msg.tp||'items'
					//         	}
					//         	me.onBtnClicked({target:el, stopPropagation:function(){} });
				}
			}
		},

		computed: {
			...mapState(['mode']),

			active() {
				return this.miniapp && this.showing;
			},

			url() {
				const fromType = '';
				const from = 'web';
				const q = encode_link(this.miniapp);
				const bid = this.miniapp.bid;
				const viewId = this.miniapp.viewid;
				const test = this.mode !== 'normal';
				// const anyhook_code = localStorage.getItem('anyhook_code');
				// const anyhook_uid = localStorage.getItem('anyhook_uid');
				// const cookie_timeout = localStorage.getItem('cookie_timeout');

				// return `${process.env.VUE_APP_MINIAPP_HOST}?type=app&from-type=${fromType}&from=${from}&q=${q}&u=widget%3A%2F%2Fapp&b=${bid}&v=${viewId}${test ? '&test=1' : ''}${anyhook_code ? `&anyhook_code=${anyhook_code}` : ''}${anyhook_uid ? `&anyhook_uid=${anyhook_uid}` : ''}${![null, undefined, ''].includes(cookie_timeout) ? `&cookie_timeout=${cookie_timeout}` : ''}`;
				return `${process.env.VUE_APP_MINIAPP_HOST}?type=app&from-type=${fromType}&from=${from}&q=${q}&u=widget%3A%2F%2Fapp&b=${bid}&v=${viewId}${test ? '&test=1' : ''}`;
			}
		},

		// watch: {
		// 	active() {
		// 		if (!this.active) return;
		// 		this.$nextTick(() => {
		// 			this.$refs.model.querySelector('iframe').contentWindow.parent.removeEventListener('message', this.onWindowMessage);
		// 			this.$refs.model.querySelector('iframe').contentWindow.parent.addEventListener('message', this.onWindowMessage.bind(this));
		// 			console.log(this.$refs.model.querySelector('iframe').contentWindow);
		// 			console.log('event attached');
		// 		});
		// 	}
		// },

		mounted() {
			if (!this.binded) {
				whevent.on('MINIAPP', this.onMiniapp, this);
				window.addEventListener('message', this.onWindowMessage.bind(this));
			}
			this.binded = true;
		},

		beforeUnmount() {
			whevent.off('MINIAPP', this.onMiniapp);
			window.removeEventListener('message', this.onWindowMessage.bind(this));
		}
	};
</script>

<style lang="scss" scoped>
	.Miniapp {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		pointer-events: none;
		background-color: rgba(0, 0, 0, 0.5);
		opacity: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: opacity 0.3s;

		&.active {
			pointer-events: all;
			opacity: 1;

			.model {
				transform: translateY(0rem);
			}
		}

		.dismiss {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: 0;
		}

		.model {
			display: block;
			position: relative;
			background-color: white;
			width: calc(100% - 6rem);
			height: calc(100% - 6rem);
			border-radius: 1rem;
			z-index: 1;
			overflow: hidden;
			transform: translateY(50rem);
			transition: transform 0.3s cubic-bezier(0.14, 0.81, 0.67, 1.23);

			iframe {
				width: 100%;
				height: 100%;
				border: none;
			}
		}
	}
</style>
